// «Исходил из: … Изменить» под ответом бытовой задачи. SMY-497 · 27.10.2026
//
// Одной строкой, а не чипами (решение владельца В2): под ответом уже стоят
// строка запуска, источники и ряд действий, и третий ряд кнопок читался бы
// отдельной записью. Строка режется многоточием, целиком допущения видны в
// раскрытом списке. Тексты — ядро (`assumptions.ts`, копия таблицы
// docs/copy/household-task-catalog.md); где блок стоит — решает экран
// правилом ядра `assumptionsPlace`, а не этот компонент.
//
// Пункт списка не отправляет ничего сам (В3): он кладёт начало правки в поле
// (`withAssumptionEdit`), человек дописывает и отправляет обычной отправкой —
// там и решается, бесплатная это правка, уточнение или платный запуск с
// подтверждением (В4). Своего правила списания у кнопки нет.
//
// Цену блок только НАЗЫВАЕТ (В4-Б, 27.10.2026): правка спишется — серая
// строка под строкой «Исходил из» и подписи для чтения с экрана. Кнопка
// остаётся «Изменить»: «Изменить за 1 документ» без «с лимита» читается
// ценником. Спишется ли — решает экран правилом ядра `assumptionPaidUnit`.

import { useId, useState } from 'react'
import {
  ASSUMPTION_TEXT,
  assumptionA11y,
  assumptionLine,
  assumptionPaidA11y,
  assumptionPaidNote,
  type Assumption,
  type UnitId,
} from '@smyslika/core'

export interface AssumptionsProps {
  /** Строки типа; пусто — компонент не рисуется. */
  list: readonly Assumption[]
  /** Пункт выбран: экран кладёт заготовку в поле и ставит туда фокус. */
  onPick: (a: Assumption) => void
  /** Правка спишется этой единицей — блок называет цену; null — бесплатно. */
  paid?: UnitId | null
}

/** «Исходил из: … Изменить» под ответом и раскрываемый список допущений (SMY-497). */
export function Assumptions({ list, onPick, paid = null }: AssumptionsProps) {
  const [open, setOpen] = useState(false)
  const listId = useId()
  if (list.length === 0) return null
  const note = paid != null ? assumptionPaidNote(paid) : null

  return (
    <div className="assumptions">
      <p className="assumptions__line">
        <span className="assumptions__text">
          {ASSUMPTION_TEXT.heading} {assumptionLine(list)}
        </span>
        <button
          type="button"
          className="assumptions__toggle"
          aria-expanded={open}
          aria-controls={listId}
          // Подпись с ценой — только у свёрнутой: раскрытая кнопка видна как
          // «Свернуть», и подпись должна начинаться с видимого слова.
          {...(note != null && !open ? { 'aria-label': note } : {})}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? ASSUMPTION_TEXT.collapse : ASSUMPTION_TEXT.edit}
        </button>
      </p>
      {/* Чтение с экрана её пропускает: то же говорит подпись кнопки. */}
      {note != null ? (
        <p className="assumptions__paid" aria-hidden="true">
          {note}
        </p>
      ) : null}
      {open ? (
        <div id={listId} className="assumptions__list">
          <p className="assumptions__hint">{ASSUMPTION_TEXT.hint}</p>
          {list.map((a) => (
            <button
              key={a.edit}
              type="button"
              className="chip assumptions__item"
              aria-label={paid != null ? assumptionPaidA11y(a) : assumptionA11y(a)}
              onClick={() => {
                // Список сворачивается: выбор сделан, дальше работа в поле.
                setOpen(false)
                onPick(a)
              }}
            >
              {a.text}
            </button>
          ))}
        </div>
      ) : null}
    </div>
  )
}
